import { render, staticRenderFns } from "./removeConfirmModal.vue?vue&type=template&id=e0bbf70e&scoped=true&"
import script from "./removeConfirmModal.vue?vue&type=script&lang=js&"
export * from "./removeConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./removeConfirmModal.vue?vue&type=style&index=0&id=e0bbf70e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bbf70e",
  null
  
)

export default component.exports